<template>
  <table class="table">
    <thead>
    <slot name="columns">
      <tr>
        <th v-for="column in columns"
            :key="column.field"
            :class="column.class || ''"
            :style="`min-width: ${column.minWidth || '100%'};`">
          {{column.label}}
        </th>
        <th v-if="actions.length !== 0" class="beast-action-table">Actions</th>
      </tr>
    </slot>
    </thead>
    <tbody>
    <tr :key="itemToString(item)" v-for="item in data">
      <slot :row="item">
        <td v-for="column in columns"
            :key="column.field"
            :class="column.class || ''"
            v-html="extractValue(item, column.field, column)"></td>
        <td v-if="actions.length !== 0" class="beast-action-table">
          <div class="btn-group">
            <button v-for="action in getActions(item)"
                    :key="action.label"
                    class="btn"
                    :class="action.class"
                    @click="performAction(action, item)">
              <span v-if="!action.icon">{{action.label}}</span>
              <font-awesome-icon
                v-if="!!action.icon"
                :icon="action.icon"
                v-tooltip.top-center="action.label">
              </font-awesome-icon>
            </button>
          </div>
        </td>
      </slot>
    </tr>
    </tbody>
  </table>
</template>
<script>
import Swal from "sweetalert2";

export default {
  name: "l-table",
  props: {
    columns: Array,
    data: Array,
    actions: {
      type: Array,
      default: () => []
    }
  },
  methods: {
    getActions(item) {
      return this.actions
        .filter(action => (action.check !== null && action.check !== undefined
          ? action.check(item)
          : true));
    },

    extractValue(item, field, columnDefinition) {
      const fieldSplit = field.split(".");
      const decorator = columnDefinition.template
        ? columnDefinition.template
        : (value => value);

      if (fieldSplit.length === 1) {
        return decorator(item[field], item);
      }

      let value = item;
      for (const fieldValue of fieldSplit) {
        if (!value[fieldValue]) {
          return "";
        }
        value = value[fieldValue];
      }

      return decorator(value, item);
    },
    itemToString(item) {
      return item[this.columns[0].field];
    },
    performAction(action, item) {
      if (action.delete) {
        this.performDelete(action, item);
        return;
      }

      if (action.action) {
        action.action(item);
      } else {
        let path = `${this.$route.path}/${action.href}`;
        Object.keys(item).forEach((element) => {
          path = path.replace(new RegExp(`:${element}`), item[element]);
        });
        this.$router.push(path);
      }
    },
    async performDelete(action, item) {
      const swalWithBootstrapButtons = Swal.mixin({
        confirmButtonClass: "btn btn-success",
        cancelButtonClass: "btn btn-danger",
        buttonsStyling: false,
      });

      const result = await swalWithBootstrapButtons({
        title: `Are you sure you want to delete item: ${item[action.value || action.key]}?`,
        text: "You won't be able to revert this!",
        type: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes, delete it!",
        cancelButtonText: "No, cancel!",
        reverseButtons: true
      });

      if (result.value) {
        this.$emit("delete", item[action.key], () => {
          swalWithBootstrapButtons(
            "Deleted!",
            "You've successfully delete the record.",
            "success"
          );
        });
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        swalWithBootstrapButtons(
          "Cancelled",
          "Your record is safe",
          "error"
        );
      }
    }
  }
};
</script>
<style scoped>
  .beast-action-table .btn {
    padding: 2px 8px;
  }
  td.beast-action-table {
    display: table-cell !important;
  }
</style>
